import { helper } from '@ember/component/helper';

// Natural sort comparison function that handles numeric strings correctly
function naturalCompare(a, b) {
  // Handle null/undefined - they should sort to the end
  const aIsNullish = a === null || a === undefined || a === '';
  const bIsNullish = b === null || b === undefined || b === '';

  if (aIsNullish && bIsNullish) return 0;
  if (aIsNullish) return 1;  // a goes after b
  if (bIsNullish) return -1; // b goes after a

  // Convert to strings
  const aStr = a.toString();
  const bStr = b.toString();

  // Split strings into parts (numbers and non-numbers)
  const aParts = aStr.match(/(\d+|\D+)/g) || [];
  const bParts = bStr.match(/(\d+|\D+)/g) || [];

  const maxLen = Math.max(aParts.length, bParts.length);

  for (let i = 0; i < maxLen; i++) {
    const aPart = aParts[i] || '';
    const bPart = bParts[i] || '';

    // Check if both parts are numeric
    const aIsNum = /^\d+$/.test(aPart);
    const bIsNum = /^\d+$/.test(bPart);

    if (aIsNum && bIsNum) {
      // Compare as numbers
      const diff = parseInt(aPart, 10) - parseInt(bPart, 10);
      if (diff !== 0) return diff;
    } else {
      // Compare as strings (case-insensitive)
      const diff = aPart.toLowerCase().localeCompare(bPart.toLowerCase());
      if (diff !== 0) return diff;
    }
  }

  return 0;
}

export function naturalSort([array, ...properties]) {
  if (!array) {
    return [];
  }

  const sortedArray = array.slice(); // Create a copy to avoid mutation

  sortedArray.sort((a, b) => {
    if (properties.length > 0) {
      // Sort by multiple properties in order
      for (const property of properties) {
        const aValue = a[property];
        const bValue = b[property];
        const comparison = naturalCompare(aValue, bValue);
        if (comparison !== 0) {
          return comparison;
        }
      }
      return 0;
    } else {
      // Sort array items directly
      return naturalCompare(a, b);
    }
  });

  return sortedArray;
}

export default helper(naturalSort);
